import { Payments } from '@utils/api';
import useCognito from '@as_core/account/useCognito';
import { handleError } from '@utils/misc';

const useProducts = () => {
  const { getToken } = useCognito();

  const createSession = async (sessionData) => {
    const token = getToken();
    let resp;

    try {
      resp = await Payments.createCheckOut(token, sessionData);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  return {
    createSession,
  };
};

export default useProducts;
